export default __webpack_public_path__ + "21e311078c462c80fc4ed60f3a51ef58.png";